import { API } from '~/types/api'

export default {
  autocomplete: ['/rest/v1/autocomplete', {}, {
    highschool: { method: 'GET', url: '/jsonapi/highschool{?filter}' },
    university: { method: 'GET', url: '/jsonapi/college{?filter}' },
    stateAndCity: { method: 'GET', url: '/rest/v1/autocomplete/state_and_city{/zip}' }
  }],
  account: ['/rest/v1/account{/id}', {}, {
    profile: { method: 'GET', url: '/rest/v1/account/profile{/id}' },
    profileUpdate: { method: 'PUT', url: '/rest/v1/account/profile{/id}' },
    profileUpdateJsonApi: { method: 'PATCH', url: '/jsonapi/profile/{accountId}' },
    register: { method: 'POST', url: '/rest/v1/account/register' },
    options: { method: 'GET', url: '/rest/v1/account/{id}/options' },
    login: { method: 'POST', url: '/rest/v1/auth/session' },
    accountInfo: { method: 'GET', url: '/rest/v1/account-info{?fields}' },
    eligibilityInitial: { method: 'GET', url: '/rest/v1/eligibility-initial' },
    account: { method: 'GET', url: '/jsonapi/account/{id}{/feature}{?include}' },
    accountUpdate: { method: 'PATCH', url: '/jsonapi/account/{accountId}' },
    params: { method: 'GET', url: '/rest/v1/pixel-params' },
    setPackages: { method: 'GET', url: '/jsonapi/account/paymentPopupDetails' }
  }],
  scholarship: ['/rest/v1/scholarship/', {}, {
    scholarshipList: { method: 'GET', url: '/rest/v1/scholarship/list' },
    applicationList: { method: 'GET', url: '/rest/v1/application/list' },
    scholarship: { method: 'GET', url: '/rest/v1/scholarship/{id}' },
    get: { method: 'GET', url: '/jsonapi/scholarship/{id}' },
    application: { method: 'GET', url: '/rest/v1/application/{id}' },
    applicationPatch: { method: 'PATCH', url: '/rest/v1/application/{id}' },
    scholarships: { method: 'GET', url: '/rest/v1/scholarship/eligible' },
    apply: { method: 'POST', url: '/rest/v1/application' },
    applyText: { method: 'POST', url: '/rest/v1/application/text/' },
    applyFile: { method: 'POST', url: '/rest/v1/application/file/' },
    applyImage: { method: 'POST', url: '/rest/v1/application/image/' },
    applyInput: { method: 'POST', url: '/rest/v1/application/input/' },
    applySurvey: { method: 'POST', url: '/rest/v1/application/survey/' },
    'applySpecial-eligibility': { method: 'POST', url: '/rest/v1/application/special-eligibility/' },
    'deleteSpecial-eligibility': { method: 'DELETE', url: '/rest/v1/application/special-eligibility/{id}' },
    markFavorite: { method: 'POST', url: '/rest/v1/scholarship/favorite/{id}' },
    unmarkFavorite: { method: 'DELETE', url: '/rest/v1/scholarship/unfavorite/{id}' },
    markIgnored: { method: 'POST', url: '/rest/v1/scholarship/ignore/{id}' },
    markUnignored: { method: 'POST', url: '/rest/v1/scholarship/unignore/{id}' },
    deleteText: { method: 'DELETE', url: '/rest/v1/application/text/{id}' },
    deleteFile: { method: 'DELETE', url: '/rest/v1/application/file/{id}' },
    deleteImage: { method: 'DELETE', url: '/rest/v1/application/image/{id}' },
    deleteInput: { method: 'DELETE', url: '/rest/v1/application/input/{id}' },
    deleteSurvey: { method: 'DELETE', url: '/rest/v1/application/survey/{id}' },
    seenScholarship: { method: 'POST', url: '/rest/v1/scholarship/seen/{id}' },
    applicationReview: { method: 'GET', url: '/rest/v1/application/preview/{id}' },
    withOnlyEligibilities: { method: 'GET', url: '/jsonapi/scholarship/{id}?include=eligibilities&fields[scholarship]=title,applicationType,eligibilities&fields[eligibility]=type,value,isOptional,field' },
    similar: { method: 'GET', url: '/jsonapi/scholarship/{id}/similar{?q*}' },
    eligibleSorted: { method: 'GET', url: '/jsonapi/account/{id}/eligibleSorted' },
    eligibilities: { method: 'GET', url: '/jsonapi/scholarship/{id}/eligibilities' },
    providerStats: { method: 'GET', url: '/jsonapi/scholarship/{id}?meta=providerStats&fields[scholarship]=meta' }
  }],
  gameStreak: ['/jsonapi/account', {}, {
    getStreaks: { method: 'GET', url: '/jsonapi/account/{accountId}/gameStreak{?attrs*}' },
    createStreak: { method: 'POST', url: '/jsonapi/gameStreak' },
    updateStreak: { method: 'PATCH', url: '/jsonapi/gameStreak/{streakId}' }
  }],
  eligibilityCache: ['/rest/v1/eligibility_cache', {}, {
    retrieve: { method: 'GET', url: '/rest/v1/eligibility_cache{?fields}' },
    update: { method: 'PUT', url: '/rest/v1/eligibility_cache' }
  }],
  recommended: ['/rest/v1/r12n', {}, {
    fetchScholarships: { method: 'GET', url: '/rest/v1/r12n' }
  }],
  cardReport: ['/rest/v1/report', {}, {
    options: { method: 'GET', url: '/rest/v1/report/options' },
    reportScholarship: { method: 'POST', url: '/rest/v1/report/scholarship' }
  }],
  winners: ['/rest/v1/winner/', {}, {
    winners: { method: 'GET', url: '/rest/v1/winner?perPage=1000' },
    winner: { method: 'GET', url: '/rest/v1/winner{/id}' },
    scholarshipWinner: { method: 'GET', url: '/jsonapi/scholarship/{scholarshipId}/winner' },
    latest: { method: 'GET', url: '/jsonapi/winner?page[number]=1&page[size]=1&sort=-id&include=scholarship&filter[published]=1' },
    latestByScholarshipId: { method: 'GET', url: '/jsonapi/winner?filter[previousWinnerForScholarship]={id}&filter[published]=1&sort=-id&page[number]=1&page[size]=3' },
    byId: { method: 'GET', url: '/jsonapi/winner?filter[id]={id}' }
  }],
  payment: ['/payment', {}, {
    retrieveBraintreeToken: { method: 'GET', url: '/braintree/token' },
    sendTokenizedData: { method: 'POST', url: '/braintree' },
    applyFreemiumPackage: { method: 'GET', url: '/apply-freemium/{id}' },
    stripeIntent: { method: 'GET', url: '/stripe/intent?package_id={packageId}' },
    stripeSubscribe: { method: 'POST', url: '/stripe/subscription?package_id={packageId}&intent_id={intentId}&payment_method_id={paymentMethodId}' },
    stripeUnsubscribe: { method: 'POST', url: '/stripe/unsubscribe?external_subscription_id={id}' },
    refreshCSRF: { method: 'GET', url: '/refresh-csrf' }
  }],
  subscription: ['/jsonapi/subscription/', {}, {
    cancel: { method: 'PUT', url: '/rest/v1/subscription/cancel/{id}' },
    cancellationSurvey: { method: 'POST', url: '/jsonapi/subscriptionCancellationSurvey' },
    applyDiscount: { method: 'POST', url: '/rest/v1/subscription/apply-discount' },
    cancellationSurveyList: { method: 'GET', url: '/jsonapi/subscriptionCancellationSurvey/options' },
    updateMaintenanceMode: { method: 'PATCH', url: '/jsonapi/subscription/{id}' },
    setFreemium: { method: 'POST', url: '/jsonapi/subscription/freemium' }
  }],
  engagement: ['/jsonapi/noEngagementSurvey/', {}, {
    getOptions: { method: 'GET', url: '/jsonapi/noEngagementSurvey/options' },
    postOption: { method: 'POST', url: '/jsonapi/noEngagementSurvey' }
  }],
  'sspa-resource': ['/rest/v1/sspa/opt-out', {}, {
    optOut: { method: 'POST', url: 'rest/v1/sspa/opt-out' },
    archiveInfo: { method: 'GET', url: 'rest/v1/ccpa/ccpa-archive-info' }
  }],
  profile: ['/', {}, {
    recurrence: { method: 'POST', url: '/post-recurrence' }
  }],
  options: ['/rest/v1/options', {}, {
    get: { method: 'GET', url: '/rest/v1/options' },
    account: { method: 'GET', url: '/rest/v1/options{/id}' }
  }],
  dictionaries: ['/jsonapi', {}, {
    degree: { method: 'GET', url: '/jsonapi/degree' },
    degreeType: { method: 'GET', url: '/jsonapi/degreeType' },
    schoolLevel: { method: 'GET', url: '/jsonapi/schoolLevel' }
  }],
  mailbox: ['/jsonapi/mailbox/', {}, {
    get: { method: 'GET', url: '/jsonapi/mailbox/{emailId}?account={accountId}' },
    index: { method: 'GET', url: '/jsonapi/mailbox/?filter[folder]={type}&filter[account]={accountId}' },
    update: { method: 'PATCH', url: '/jsonapi/mailbox/{emailId}?account={accountId}' },
    metaData: { method: 'GET', url: '/jsonapi/account/{id}?meta=mailbox' }
  }],
  applicationGoal: ['/jsonapi/applicationGoal/', {}, {
    get: { method: 'GET', url: '/jsonapi/applicationGoal/{applicationGoalId}' },
    post: { method: 'POST', url: '/jsonapi/applicationGoal' }
  }],
  accountConfigAutoApplication: ['/jsonapi/accountConfigAutoApplication/', {}, {
    get: { method: 'GET', url: '/jsonapi/accountConfigAutoApplication/{accountId}' },
    set: { method: 'PATCH', url: '/jsonapi/accountConfigAutoApplication/{accountId}' }
  }]
} as API.Actions
